import axios from 'axios'

export default {
    // Current User
    saveUserProfile ({ state, commit }, form) {
        return form.put(`/api/me`).then((response) => {
            commit('setCurrentUser', response.data)
        })
    },

    uploadAvatar ({ state, commit }, form) {
        return form.post(`/api/me/avatar`).then((response) => {
            commit('setCurrentUser', response)
        })
    },

    removeAvatar ({ commit }) {
        return axios.delete(`/api/me/avatar`).then((response) => {
            commit('setCurrentUser', response.data)
        })
    },

    sendEmailChangeRequest ({ commit }, form) {
        return form.post(`/api/me/email-change-request`)
    },

    changePassword ({ commit }, form) {
        return form.put(`/api/me/password`)
    }
}
